import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTable, usePagination, useSortBy } from "react-table";
import withLoading from "../hoc/withLoading";
import headerDefinitions from "../tableheaders/license.tableheader.json";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import helpers from "../helpers/function.helper";
import { getList, create, edit, getInstitutionList } from "../api/license.api";
import { exportDataDownload } from "../api/users.api";
import Swal from "sweetalert2";
import viewIcon from "../assets/icons/view.png";
import editIcon from "../assets/icons/edit.png";
import formIcon from "../assets/icons/form.png";
import downloadIcon from "../assets/icons/download.png";
import deleteIcon from "../assets/icons/delete.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import TableHeaderButton from "../components/TableHeaderButton";
import ReactDatePicker from "react-datepicker";
import { showCreateDialog, showDownloadDialog, showErrorDialog } from "../components/Dialog";
import EnumRoles from "../constants/EnumRoles";
import LoadingComponent from "../components/Loading";

const baseURL = process.env.REACT_APP_API_ENDPOINT;
const License = ({user}) => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [isLoading, setLoading] = useState(true);

  // -------------------- Data Table ----------------------------------------
  const headersData = headerDefinitions.columns;
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [pageCount, setPageCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dataTable, setDatatable] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [canNextPage, setCanNextPage] = useState(true);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const tableData = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => headersData, [headersData]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: tableData,
      },
      useSortBy,
      usePagination
    );

  const toggleRowSelection = (Id) => {
    setSelectedRowIds((prev) => {
      if (prev.includes(Id)) {
        // If already selected, remove it
        return prev.filter((id) => id !== Id);
      } else {
        // Otherwise, add it
        return [...prev, Id];
      }
    });
  };

  const handleSort = async (columnId) => {
    // Will Sort By *accessor* in HeaderJSON File
    setSortConfig((prevSortConfig) => {
      let direction = "ASC";
      if (
        prevSortConfig.key === columnId &&
        prevSortConfig.direction === "ASC"
      ) {
        direction = "DESC";
      }
      return { key: columnId, direction };
    });
  };

  const handleNextPage = () => {
    setPageIndex((current) => {
      const nextPageIndex = current + 1;
      setCanNextPage(nextPageIndex < pageCount - 1);
      setCanPreviousPage(true);
      return nextPageIndex;
    });
  };

  const handlePreviousPage = () => {
    setPageIndex((current) => {
      const previousPageIndex = Math.max(0, current - 1);
      setCanPreviousPage(previousPageIndex > 0);
      setCanNextPage(true);
      return previousPageIndex;
    });
  };

  // -------------------- Data Table ----------------------------------------

  const clearSearch = () => {
    setKeyword("");
    setSortConfig({ key: "", direction: "" });
    setRowsPerPage(10);
    setPageIndex(0);
  };

  const fetchData = async (is_search = false) => {
    try {
      setLoading(true);
      const { data, totalPages } = await getList({
        page_number: is_search ? 0 : pageIndex,
        data_per_page: is_search ? 10 : rowsPerPage,
        keyword: keyword,
        sort_key: sortConfig.key,
        sort_order: sortConfig.direction,
      });
      if (data) {
        setDatatable(data);
        setPageCount(totalPages);
        setCanNextPage((is_search ? 0 : pageIndex) < Math.ceil(totalPages / (is_search ? 10 : rowsPerPage)) - 1);
        setCanPreviousPage((is_search ? 0 : pageIndex) > 0);
      }
    } catch (error) {
      console.error("Fetch Data Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportData = async () => {
    try {

      const result = await showDownloadDialog();
      if (!result.isConfirmed) {
        return; 
      }

      let namePage = "License";
      let apiPath = `/license/export`;
      setLoading(true);
      await exportDataDownload(apiPath, namePage);
      setLoading(false);

    } catch (error) {
      console.log(error);
      showErrorDialog('เกิดข้อผิดพลาด')
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageIndex, rowsPerPage, sortConfig]);

  return (
  <>
    {isLoading ? (
        <LoadingComponent/>
      ) : (
      <div className="container-fluid">
        <div className="box-white">
          <h2>ใบอนุญาต</h2>

          <Row className="mb-3">
            <Col md={"auto"}>
            {user?.role?.name === EnumRoles.SUPERADMIN ? (
              <button
              className="custom-btn btn-create m-1"
              onClick={() => navigate("/licenses/action?method=create")}
            >
              <FontAwesomeIcon icon={faPlus} />{" "}
              <span className="mx-1">เพิ่มใบอนุญาต</span>
            </button>
            ):(<></>)}

              <button
                className="custom-btn btn-secondary-custom m-1"
                onClick={() => handleExportData()}
              >
                <img src={downloadIcon} alt="Download" className="icon" />{" "}
                <span className="mx-1">ดาวน์โหลด</span>
              </button>
            </Col>
          </Row>
          <div className="d-flex justify-content-between align-items-center mx-2 py-3">
            <div className="d-none d-md-block">
              <span className="pr-2 align-self-center text-sm fw-bold">
                Show :{" "}
              </span>
              <label>
                <select
                  style={{ border: "none", cursor: "pointer" }}
                  className="select-page mr-2"
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                  <option value={1000}>1000</option>
                </select>
              </label>
              <label>Entries</label>
            </div>
            <div className="d-flex search-container">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="ค้นหา"
                className="search-input"
              />
              <button className="search-button" onClick={() => fetchData(true)}>
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
          </div>
          <div style={{ overflow: "auto" }}>
            <Table
              striped
              bordered
              {...getTableProps()}
              className="table text-center"
              style={{ borderCollapse: "collapse" }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr key={"head"} {...headerGroup.getHeaderGroupProps()}>
                    <th>ลำดับ</th>
                    {headerGroup.headers.map((column) => {
                      const { key, ...rest } = column.getHeaderProps(); // Separate key from other props
                      return (
                        <th key={key} {...rest}>
                          {column.render("Header")}
                          {/* Add a clickable sort icon */}
                          <TableHeaderButton
                            column={column}
                            sortConfig={sortConfig}
                            handleSort={handleSort}
                          />
                        </th>
                      );
                    })}
                    {/* <th>เครื่องมือ</th> */}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                <tr className="space-table"></tr>
                {rows.length > 0 ? (
                  rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const actualIndex = pageIndex * rowsPerPage + rowIndex + 1;
                    const isSelected = selectedRowIds.includes(
                      row.original.lic_id
                    );

                    // Extract key from row.getRowProps()
                    const { key, ...rest } = row.getRowProps();

                    return (
                      <tr
                        key={key} // Pass key directly here
                        {...rest}
                        onClick={() => toggleRowSelection(row.original.lic_id)}
                        className={isSelected ? "selected-row" : ""}
                        style={isSelected ? { backgroundColor: "#f0f0f0" } : {}}
                      >
                        <td>{actualIndex}</td>
                        <td>{row.original?.institution?.ins_name ?? ""}</td>
                        <td>
                          {`${(row.original?.lic_count ?? 0)} / ${((row.original?.license_insitution?.length ?? 0) + (row.original?.lic_count ?? 0))}`}
                        </td>
                        <td>
                          {helpers.formatDateThai(row.original?.lic_ready) ??
                            ""}
                        </td>
                        <td style={{ color: helpers.getTextColor(row.original?.lic_expired) }}>
                          {helpers.formatDateThai(row.original?.lic_expired) ?? ""}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="text-center">
                    <td colSpan={100} style={{ textAlignLast: "center" }}>
                      ไม่พบข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div
            className="py-3 mx-2"
            style={{ display: "flex", justifyContent: "right" }}
          >
            {/* Pagination */}
            <div className="mt-2">
              <span>
                {`${pageIndex * rowsPerPage + 1} - ${
                  (pageIndex + 1) * rowsPerPage
                } จาก ${pageCount} `}
              </span>
              <button
                className="mx-1 px-3 icon-btn"
                onClick={handlePreviousPage}
                disabled={!canPreviousPage}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <span> {pageIndex + 1}</span>
              <button
                className="mx-1 px-3 icon-btn"
                onClick={handleNextPage}
                disabled={!canNextPage}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
              <span>{Math.ceil(pageCount / rowsPerPage)}</span>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
  );
};

export default withLoading(License);
